module.exports = __webpack_public_path__ + "static/img/client6.b5f91376.jpg";